var map = {
	"./heart.png": 693,
	"./heart.webp": 469,
	"./message.png": 694,
	"./message.webp": 470,
	"./star.png": 695,
	"./star.webp": 471,
	"./wallet.png": 696,
	"./wallet.webp": 472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 692;